import PrenotazioniCupList from "./pages/PrenotazioniCupList.vue";
// import AmbulatorioView from "./components/AmbulatorioView.vue";
import PrenotazioniCupEdit from "./pages/PrenotazioniCupEdit.vue";

export default {
    PrenotazioniCupList,
    // AmbulatorioView,
    PrenotazioniCupEdit,
};
